namespace Matrix.Data {
    export interface TestResultMuteRow {
        TestCode?: string;
        ResultSignature?: number[];
        MuteUntil?: string;
        Comment?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        TestCodeDescription?: string;
        TestCodeEnabled?: boolean;
        TestCodeTestTypeCode?: string;
        TestCodePriority?: string;
        TestCodeScript?: string;
        TestCodeLastRunBatchId?: number;
        TestCodeLastResultCode?: string;
        TestCodeRowId?: number;
        TestCodeVersion?: number;
        TestCodeCreatedBy?: string;
        TestCodeCreatedWhen?: string;
        TestCodeUpdatedBy?: string;
        TestCodeUpdatedWhen?: string;
    }

    export namespace TestResultMuteRow {
        export const idProperty = 'RowId';
        export const nameProperty = 'TestCode';
        export const localTextPrefix = 'Data.TestResultMute';
        export const deletePermission = 'DataAdmin:TestResultMute';
        export const insertPermission = 'DataAdmin:TestResultMute';
        export const readPermission = 'Read:TestResultMute';
        export const updatePermission = 'DataAdmin:TestResultMute';

        export declare const enum Fields {
            TestCode = "TestCode",
            ResultSignature = "ResultSignature",
            MuteUntil = "MuteUntil",
            Comment = "Comment",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            TestCodeDescription = "TestCodeDescription",
            TestCodeEnabled = "TestCodeEnabled",
            TestCodeTestTypeCode = "TestCodeTestTypeCode",
            TestCodePriority = "TestCodePriority",
            TestCodeScript = "TestCodeScript",
            TestCodeLastRunBatchId = "TestCodeLastRunBatchId",
            TestCodeLastResultCode = "TestCodeLastResultCode",
            TestCodeRowId = "TestCodeRowId",
            TestCodeVersion = "TestCodeVersion",
            TestCodeCreatedBy = "TestCodeCreatedBy",
            TestCodeCreatedWhen = "TestCodeCreatedWhen",
            TestCodeUpdatedBy = "TestCodeUpdatedBy",
            TestCodeUpdatedWhen = "TestCodeUpdatedWhen"
        }
    }
}
